import {
  StartTeacherSupportMutation,
  StartTeacherSupportMutationVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useMutation } from "@outschool/ui-apollo";

export const START_TEACHER_SUPPORT_MUTATION = gql`
  mutation StartTeacherSupport($sectionUid: ID!) {
    startTeacherSupport(sectionUid: $sectionUid) {
      uid
      teacher_support_start_time
      end_time
    }
  }
`;

export const useStartTeacherSupportMutation = () =>
  useMutation<
    StartTeacherSupportMutation,
    StartTeacherSupportMutationVariables
  >(START_TEACHER_SUPPORT_MUTATION);
